import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ color = "#ec8c22" }) => {
  return (
    <svg
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 1.00003L1 8" stroke={color} strokeWidth="1" />
      <path d="M8 8L1 0.999998" stroke={color} strokeWidth="1" />
    </svg>
  );
};

export default memo(Icon);
